import React, { useEffect, useState } from 'react';
import Loading from '../../collection/icons/Loading';
import { apiGet, apiUrl } from '../../utils/api';

export default function Docs(props) {
    // api call
    const [data, setData] = useState();
    const updateData = async () => setData(await apiGet("docs/list"));
    useEffect(() => { updateData(); }, []);

    // render
    return <>
        <h2>Documentos de interés</h2>
        {data ? (Object.keys(data).length > 0 ?
            Object.entries(data).map(doc => (
                <div key={doc[1]}><a href={apiUrl(`docs/get/${doc[1]}`)} target="_blank">{doc[0]}</a><br /></div>
            ))
            : "No hay documentos que mostrar.") : <Loading />}
    </>;
}
